import { Alert, AlertTitle, Stack, Typography } from '@mui/material'

import { AlertSeverity, IAlert, IAlertsResponse } from '../types'

interface IProps {
  data: IAlertsResponse
}

const severityToMui: Record<AlertSeverity, 'error' | 'warning' | 'info'> = {
  critical: 'error',
  warning: 'warning',
  info: 'info',
}

export function AlertsList({ data }: IProps) {
  if (data.alerts.length === 0) {
    return <Typography variant="body2" color="text.secondary">Nenhum alerta ativo.</Typography>
  }
  return (
    <Stack spacing={1}>
      {data.alerts.map((a: IAlert) => (
        <Alert key={a.id} severity={severityToMui[a.severity]}>
          <AlertTitle>{a.title} — {a.count}</AlertTitle>
          <Typography variant="body2">{a.recommended_action}</Typography>
        </Alert>
      ))}
    </Stack>
  )
}
